import React from 'react';

import {Trans, useTranslation} from 'react-i18next';
import {
    FontVariant,
    TextHeading,
    Text,
    Form,
    Bar,
    Button,
} from '@pexip/components';
import {TestId} from '../../../test/testIds';

export const RegistrationSuccess: React.FC<{
    onDone: () => void;
}> = ({onDone}) => {
    const {t} = useTranslation();

    return (
        <>
            <TextHeading
                htmlTag="h2"
                fontVariant={FontVariant.H2}
                className="mb-2"
            >
                <Trans t={t} i18nKey="register.success-title">
                    You're all set
                </Trans>
            </TextHeading>
            <Text>
                <Trans t={t} i18nKey="register.success-description">
                    Your registration was successful!
                    <br />
                    You can now receive incoming calls and search your
                    organization's directory.
                </Trans>
            </Text>
            <Form
                onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
                    event.preventDefault();
                    onDone();
                }}
            >
                <Bar>
                    <Button
                        modifier="fullWidth"
                        type="submit"
                        size="large"
                        data-testid={TestId.ButtonRegistrationDone}
                        className="mt-3"
                    >
                        <Trans t={t} i18nKey="register.success-done">
                            Done
                        </Trans>
                    </Button>
                </Bar>
            </Form>
        </>
    );
};
